import {createModal} from "../../helpers/modal";
import {loading, stopLoading} from "../../helpers/loading";
import Axios from "axios";
import createElement from "../../helpers/createElement";
import handleAjaxError from "../../helpers/handleAjaxError";

/**
 * 	Initializes Js related to a VOE order processing log
 *	@param {Element} container
 */
function initProcessingLog(container) {
	const logModal = createModal({});

	// Check if container is the actual container or a parent
	if (!container.classList.contains('voe-order-processing-log-container')) {
		container = container.querySelector('.voe-order-processing-log-container');
	}

	// Scroll log to the end
	const scrollWrapper = container.querySelector('.entries-wrapper');
	scrollWrapper.scrollTop = scrollWrapper.scrollHeight;

	// Setup zoom button
	const zoomButton = container.querySelector('.zoom-button');
	if (zoomButton) {
		zoomButton.addEventListener('click', () => {
			loading();

			Axios.post(zoomButton.dataset.modalRoute)
				.then(response => {
					logModal.replace(createElement(response.data.modal));
					logModal.display();
				})
				.catch(handleAjaxError)
				.finally(stopLoading);
		})
	}
}

export {initProcessingLog}
